import React from "react"

const Show = () => {
    return (
        <div style={{ height: "auto" }} fluid>
        <p className="lead d-flex justify-content-center">
          thank you for your feedback.
        </p>
      </div>
    )

}

export default Show